import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { EmployeeService } from '../../employee-profile/employee-profile.service';
import { EmployeeModel } from 'src/app/Models/EmpCareerUser.model';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { DashboardService } from '../Dashboad.service';
import { ProgramsModel } from 'src/app/Models/esdPrograms.model';
import { ToastrService } from 'ngx-toastr';
import { GsdRoles } from 'src/app/enums/gsdRoles.enum';
import { UserService } from 'src/app/services/user.service';
import { Carousel } from 'primeng/carousel';
// import { UIChart } from 'primeng/chart';
import { ChartModule } from 'primeng/chart';
import { error } from 'console';
import { observable, Observable } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  employeeId: number;
  employeeCareerUserDetails?: EmployeeModel;
  userId: number;
  _isManager: boolean = false;
  loginemployeeId: number;

  currentDate = new Date();
  year = this.currentDate.getFullYear();
  currentMonth = this.currentDate.getMonth() + 1;
  quarterNo = Math.ceil(this.currentMonth / 3);

  _learnings: any[];
  _nextLearnings: any = [];
  _topLearners: any[];
  _teamTopLearners: any[];

  programDetails: any;
  _totalCoursesOfEmp: Number = 0;
  _completedCoursesOfEmp: Number = 0;
  _programProgress: any = {};
  _programRequestsCount: number = 0;

  public role: string;
  counts: any;
  showmydashboardbutton: boolean= false;

  @ViewChild('chart') chart: ChartModule;
  @ViewChild('chart2') chart2: ChartModule;
  @ViewChild('chart3') chart3: ChartModule;
  @ViewChild('chart4') chart4: ChartModule;
  _myTeamCourseCount: any;
  labels = [];
  labels2 = ['Jan', 'Feb', 'Mar'];
  completedCourses = [];
  totalCourses = [];
  inprogressCourses = [];
  notStartedCourses = [];
  lineChartDataItems1: any = [];
  element: any;
  element2: any;
  yearData = [2021, 2022, 2023, 2024];
  quarterData = [
    {
      id: 1,
      name: 'Q1 (Jan-Mar)'
    },
    {
      id: 2,
      name: 'Q2 (Apr-Jun)'
    },
    {
      id: 3,
      name: 'Q3 (Jul-Sep)'
    },
    {
      id: 4,
      name: 'Q4 (Oct-Dec)'
    }
  ];

  barChart = true;
  empTotalCourse: number;
  empCompletedCourses: number;
  empTotalPrograms: number;
  empCompletedPrograms: number;

  _overallTeamPrograms: number = 0;
  _overallTeamCompletedPrograms: number = 0;
  _teamPendingRequestCount: number = 0;

  projectIds: string = '';
  managerReporteesEmpIds: any[] = [];

  isViewTeamDashboard: boolean = false;
  viewName: string = 'My Dashboard';
  _empReporting: number = 0;
  _billableEmps: number = 0;
  _shadowEmps: number = 0;
  _totalProjects: any = [{}];
  _empsProjectStatus: any = [{}];
  


  constructor(private employeeService: EmployeeService, private authService: AuthServiceService, private DashboardService: DashboardService
    , private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    public userService: UserService, private router: Router,private route:ActivatedRoute) {
     
    this.isViewTeamDashboard = localStorage.getItem('isViewTeamDashboard') === 'true';
    this.viewName = this.isViewTeamDashboard ? 'Team Dashboard123' : 'My Dashboard';

    // Listen for router events to handle back navigation
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isViewTeamDashboard = localStorage.getItem('isViewTeamDashboard') === 'true';
        this.viewName = this.isViewTeamDashboard ? 'Team Dashboard' : 'My Dashboard';
      }
    });
  }

  ngOnInit() {
    
    this.route.params.subscribe(params => {
      this.employeeId = Number(params['empId']);
    });
    this.loginemployeeId = parseInt(localStorage.getItem('Id'));

    if(this.employeeId != this.loginemployeeId)
    {
      localStorage.setItem('isViewTeamDashboard', "false");
    //  this.isViewTeamDashboard =  false;
      this.viewName = this.isViewTeamDashboard ? 'Team Dashboard' : 'My Dashboard';
    }
    

    if(this.employeeId  == 0 || !this.employeeId)
    {
      this.employeeId = parseInt(localStorage.getItem("Id"));
    this.role = this.authService.getRole();
    this.setECPUserData();
    const empCareerUserId = localStorage.getItem('EmpCareerUserID');
    const empCareerUserDetails = localStorage.getItem('empCareerUserDetails');
    if (empCareerUserId && empCareerUserDetails) {
      try {
        this.employeeCareerUserDetails = JSON.parse(empCareerUserDetails);
      }
      catch (error) {
        console.error('Error parsing empCareerUserDetails from localStorage:', error);
        if (this.role.includes(GsdRoles.SkillUser)) {
          this.setECPUserData();
        }
      }
    }
    else {
      if (this.role.includes(GsdRoles.SkillUser)) {
        this.setECPUserData();
      }
    }
    }

    else{
      this.setECPUserData();
    }
    
    if(this.loginemployeeId == this.employeeId)
      {
        this.showmydashboardbutton=true;
      }
    
    setTimeout(() => this.fetchUserData().then(() => {
      this._isManager = this.employeeCareerUserDetails?.isManager;
      this.getMyLearnings();
      this.getNextLearnings();
      this.getTopLearners();
      this.fetchProgramRequestsCount();
      this.onQuarterChange();

      if (this.employeeCareerUserDetails?.isManager) {
        // ... other manager-specific functions
        this.getTeamTopLearners();
        this.getTeamProgramDetails(this.employeeId);
        this.getTeamRequestsCount(this.userId);
        this.getManagerProjectInfo(this.employeeId);
      }
    }), 1000);
    this.isViewTeamDashboard = localStorage.getItem('isViewTeamDashboard') === 'true';
    this.viewName = this.isViewTeamDashboard ? 'Team Dashboard' : 'My Dashboard';
  }
  setECPUserData() {
    
    this.authService.getEmpCareerUserInfo(this.employeeId).subscribe((empCareerModel) => {
      if (empCareerModel) {
        this.employeeCareerUserDetails = empCareerModel;
        this.userService.empCareerUserDetails.next(empCareerModel);
        localStorage.setItem('EmpCareerUserID', empCareerModel.userID.toString());
        localStorage.setItem('empCareerUserDetails', JSON.stringify(empCareerModel));
      }
      else
      {
        localStorage.setItem('EmpCareerUserID', '0');
      localStorage.setItem('empCareerUserDetails', null);
      }
    }, error => {
      localStorage.setItem('EmpCareerUserID', '0');
      localStorage.setItem('empCareerUserDetails', null);
    });
  }

  async fetchUserData() {
    
    this.userId = parseInt(localStorage.getItem("EmpCareerUserID"));
    const storedData = localStorage.getItem('empCareerUserDetails');
    if (storedData) {
      this.employeeCareerUserDetails = JSON.parse(storedData);
    } else {
      console.log("No empCareerUserFound");
    }
  }
  getMyLearnings() {
    
    this.DashboardService.getMyLearnings(this.userId).subscribe((res: any[]) => {
      if (res) {
        this._learnings = res;
        this._totalCoursesOfEmp = this._learnings.length;
      }
    }, error => {
      this._learnings=[];
      this._totalCoursesOfEmp = 0;
    })
  }

  getNextLearnings() {
    
    var model: ProgramsModel = {
      UserId: this.userId,
      PageNo: 1,
      PageSize: 4,
      Year: this.year,
      QuarterNo: this.quarterNo,
      SearchText: '',
      Departments: this.employeeCareerUserDetails?.departmentId
    };
    this.DashboardService.getNextLearnings(model).subscribe((res: any[]) => {
      if (res) {
        if (res?.length > 3) {
          var learnings = Array.from(res);
          for (let i = 0; i <= 3; i++) {
            this._nextLearnings.push(learnings[i]);
          }
        } else {
          this._nextLearnings = res;
        }
      }
    }, error => {
    })
  }

  getTopLearners() {
    this.DashboardService.getTopLearners().subscribe((res: any) => {
      if (res) {
        this._topLearners = res;
      }
    }, error => {
    })
  }
  getTeamTopLearners() {
    this.DashboardService.getTeamTopLearners(this.userId).subscribe((res: any) => {
      if (res) {
        this._teamTopLearners = res;
      }
    }, error => {
      this.toastr.error("Unable to fetch Team-top Learners...");
    });
  }

  onQuarterChange() {
    this.getEmployeeProgressCounts(this.quarterNo, this.year);
    this.getProgramCourseStatusData(this.quarterNo, this.year);
    this.getMyProgressCountsForLineChart(this.quarterNo, this.year);
    this.cdr.detectChanges();
  }
  onYearChange() {
    this.year = +this.year;
    this.getEmployeeProgressCounts(this.quarterNo, this.year);
    this.getProgramCourseStatusData(this.quarterNo, this.year);
    this.getMyProgressCountsForLineChart(this.quarterNo, this.year);
    this.cdr.detectChanges();
  }

  getEmployeeProgressCounts(quarter, year) {
    var model = {
      userId: this.userId,
      year: year,
      quarterNo: quarter
    }
    this.DashboardService.getEmployeeProgressCounts(model).subscribe((res: any) => {
      if (res) {
        this.programDetails = res;
        this.counts = res[0]?.programCourseDetailsDTO;
        this.empCompletedCourses = res[0]?.programCourseDetailsDTO.coursesCompleted;
        this.empTotalCourse = res[0]?.programCourseDetailsDTO.totalCourses;
        this.empCompletedPrograms = res[0]?.programCourseDetailsDTO.programsCompleted;
        this.empTotalPrograms = res[0]?.programCourseDetailsDTO.totalprograms

        res.forEach((program) => {
          this._programProgress[program.programId] = program.topicsInprogress > 0 ? program.programCompletedPercentage + '.5' : program.programCompletedPercentage;
        });
      }
    }, error => {
    });
  }
  fetchProgramRequestsCount() {
    this.DashboardService.fetchProgramRequestsCount(this.userId).subscribe((res: any) => {
      this._programRequestsCount = res;
    }, error => {
    })
  }
  showLineChart() {
    this.barChart = false;
  }

  showBarChart() {
    this.barChart = true;
  }
  barChartData1 = {
    labels: this.labels,
    datasets: [
      {
        label: 'Total Courses',
        backgroundColor: '#FC5C7D',
        data: this.totalCourses,
        maxBarThickness: 15,
        barThickness: 10
      },
      {
        label: 'Not Started',
        backgroundColor: '#F2BE42',
        data: this.notStartedCourses,
        maxBarThickness: 15,
        barThickness: 10
      },
      {
        label: 'Inprogress',
        backgroundColor: '#9CE280',
        data: this.inprogressCourses,
        maxBarThickness: 15,
        barThickness: 10
      },
      {
        label: 'Completed',
        backgroundColor: '#5AC2DB',
        data: this.completedCourses,
        maxBarThickness: 15,
        barThickness: 10
      },
    ],
  };

  public chartOptions = {
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          fontColor: '#52718E'
        },
        gridLines: {
          borderDash: [3, 5],
        }
      }],
      xAxes: [
        {
          display: false
        }
      ]
    },
    legend: {
      position: "bottom",
      labels: {
        fontColor: '#52718E'
      }
    }
  }

  lineChartData1 = {
    labels: this.labels2,
    datasets: [
      {
        label: 'Courses',
        fill: true,
        backgroundColor: 'rgba(33, 150, 243, 0.2)',
        borderColor: '#1E88E5',
        data: this.lineChartDataItems1
      }
    ],
  };

  chartOptions2: any = {
    legend: {
      position: 'bottom',
      labels: {
        fontColor: '#52718E'
      }
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          fontColor: '#52718E'
        },
        gridLines: {
          borderDash: [3, 5],
        }
      }]
    },
    elements: {
      line: {
        tension: 0
      }
    },
    style: {
      fill: {
        type: 'linear',
        gradient: {
          orientation: 'vertical',
          from: '#2196F3',
          to: '#E91E63'
        }
      }
    }
  };

  getMyProgressCountsForLineChart(quarter, year) {
    var model = {
      userId: this.userId,
      year: year,
      quarterNo: quarter
    }
    this.lineChartDataItems1 = [];

    this.DashboardService.getMyProgressCountsForLineChart(model).subscribe((res: any) => {
      if (res.length > 0) {
        var data = Array.from(res);
        data.forEach(x => {
          this.element = x;
          if (quarter == 1) {
            this.element.month == 1 ? this.lineChartDataItems1.push(this.element.totalCourses) : this.lineChartDataItems1.push(0);
            this.element.month == 2 ? this.lineChartDataItems1.push(this.element.totalCourses) : this.lineChartDataItems1.push(0);
            this.element.month == 3 ? this.lineChartDataItems1.push(this.element.totalCourses) : this.lineChartDataItems1.push(0);
          } else if (quarter == 2) {
            this.element.month == 4 ? this.lineChartDataItems1.push(this.element.totalCourses) : this.lineChartDataItems1.push(0);
            this.element.month == 5 ? this.lineChartDataItems1.push(this.element.totalCourses) : this.lineChartDataItems1.push(0);
            this.element.month == 6 ? this.lineChartDataItems1.push(this.element.totalCourses) : this.lineChartDataItems1.push(0);
          } else if (quarter == 3) {
            this.element.month == 7 ? this.lineChartDataItems1.push(this.element.totalCourses) : this.lineChartDataItems1.push(0);
            this.element.month == 8 ? this.lineChartDataItems1.push(this.element.totalCourses) : this.lineChartDataItems1.push(0);
            this.element.month == 9 ? this.lineChartDataItems1.push(this.element.totalCourses) : this.lineChartDataItems1.push(0);
          } else {
            this.element.month == 10 ? this.lineChartDataItems1.push(this.element.totalCourses) : this.lineChartDataItems1.push(0);
            this.element.month == 11 ? this.lineChartDataItems1.push(this.element.totalCourses) : this.lineChartDataItems1.push(0);
            this.element.month == 12 ? this.lineChartDataItems1.push(this.element.totalCourses) : this.lineChartDataItems1.push(0);
          }
        });
      } else {
        this.lineChartDataItems1 = [];
      }
      this.lineChartData1 = {
        labels: this.labels2,
        datasets: [
          {
            label: 'Courses',
            fill: true,
            backgroundColor: 'rgba(33, 150, 243, 0.2)',
            borderColor: '#1E88E5',
            data: this.lineChartDataItems1
          }
        ],
      };
      // this.chart2?.refresh();
    }, error => {
    });
  }

  getProgramCourseStatusData(quarter, year) {
    var model = {
      userId: this.userId,
      year: year,
      quarterNo: quarter
    }
    this.DashboardService.fetchProgramCourseStatusData(model).subscribe((res: any) => {
      let len = 0;
      if ((len = res.length) > 0) {
        this.labels = [];
        this.notStartedCourses = new Array(len).fill(0);
        this.inprogressCourses = new Array(len).fill(0);
        this.totalCourses = new Array(len).fill(0);
        this.completedCourses = new Array(len).fill(0);

        var data = Array.from(res);
        data.forEach(program => {
          this.element = program;

          let i = this.labels.indexOf(this.element.programName)

          if (i === -1) {
            if (!this.labels.includes(this.element.programName)) {
              i = this.labels.push(this.element.programName) - 1;
            }
          }

          if (this.element.statusName == 'NotStarted') {
            this.notStartedCourses[i] = this.element.statusCount;
          }
          else if (this.element.statusName == 'TOTAL COURSES') {
            this.totalCourses[i] = this.element.statusCount;
          }
          else if (this.element.statusName == 'In Progress') {
            this.inprogressCourses[i] = this.element.statusCount;
          }
          else if (this.element.statusName == 'Completed') {
            this.completedCourses[i] = this.element.statusCount;
          }
        })
      } else {
        this.labels = [];
        this.notStartedCourses = [];
        this.inprogressCourses = [];
        this.totalCourses = [];
        this.completedCourses = [];
      }
      this.barChartData1 = {
        labels: this.labels,
        datasets: [
          {
            label: 'Total Courses',
            backgroundColor: '#FC5C7D',
            data: this.totalCourses,
            maxBarThickness: 15,
            barThickness: 10
          },
          {
            label: 'Not Started',
            backgroundColor: '#F2BE42',
            data: this.notStartedCourses,
            maxBarThickness: 15,
            barThickness: 10
          },
          {
            label: 'Inprogress',
            backgroundColor: '#9CE280',
            data: this.inprogressCourses,
            maxBarThickness: 15,
            barThickness: 10
          },
          {
            label: 'Completed',
            backgroundColor: '#5AC2DB',
            data: this.completedCourses,
            maxBarThickness: 15,
            barThickness: 10
          },
        ],
      };
      // this.chart?.refresh();
    }, error => {
    })
  }



  changeView() {
    this.isViewTeamDashboard = this.isViewTeamDashboard ? false : true;
    this.viewName = this.viewName === 'My Dashboard' ? 'Team Dashboard' : 'My Dashboard';
    localStorage.setItem('isViewTeamDashboard', this.isViewTeamDashboard.toString());
  }
  setView(view: string) {
    this.viewName = view;
    this.isViewTeamDashboard = view === 'Team Dashboard';
    localStorage.setItem('isViewTeamDashboard', this.isViewTeamDashboard.toString());
  }

  getTeamProgramDetails(employeeId: number) {
    this.DashboardService.getTeamProgramDetails(employeeId).subscribe((res: any) => {
      if (res) {
        this._overallTeamPrograms = res.value[0]?.overallTotalPrograms;
        this._overallTeamCompletedPrograms = res.value[0]?.overallCompletedPrograms
      }
    });
  }
  getTeamRequestsCount(userId: number) {
    this.DashboardService.getTeamRequestsCount(userId).subscribe((res: number) => {
      this._teamPendingRequestCount = res;
    });
  }

  getManagerProjectInfo(employeeId: number) {
    this.DashboardService.getManagerProjectInfo(employeeId).subscribe((res: any) => {
      if (res.length == 0) {
        this.projectIds = '';
        this._totalProjects = [];
      }
      else if (res) {
        this._totalProjects?.pop();
        this._empsProjectStatus?.pop();

        res.forEach((item) => {
          this._empReporting += item.totalEmployees;
          this._billableEmps += item.billable;
          this._shadowEmps += item.shadow;
          this._totalProjects?.push({ Name: item.projectName, Employees: item.totalEmployees });
          this._empsProjectStatus?.push({ Name: item.projectName, Billable: item.billable, Shadow: item.shadow });
          this.projectIds += item.projectId + ',';
        });
        this.projectIds = this.projectIds.slice(0, -1);
        this.getManagerHeirarchy(this.projectIds);
      }
    });
  }
  getManagerHeirarchy(projectIds: string) {
    this.DashboardService.getManagerHeirarchy(projectIds).subscribe((res: any) => {
      if (res) {
        res.forEach((emp) => {
          if (!this.managerReporteesEmpIds?.includes(emp.id)) {
            this.managerReporteesEmpIds.push(emp.id);
          }
        });
      }
    });
  }
}
